import { IJsonSerializable } from "../util/interfaces"
import { Enums } from "../common"
import { OpEquipmentType } from "./op-equipment-type"
import { ReferenceTypeComponent } from "../../helpers"

export class OpEquipmentQuantity implements IJsonSerializable {

    //#region Members

    public referenceValue: any
    public referenceType: Enums.ReferenceType
    public equipmentQuantity: OpEquipmentType[]

    // #endregion

    // #region Ctor

    constructor(opObj: any) {
        this.fromJSON(opObj)
    }

    // #endregion

    //#region IJsonSerializable Implementation

    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj) {
            this.referenceValue = opObj.ReferenceValue ? ReferenceTypeComponent.createReferenceObject(opObj.ReferenceType, opObj.ReferenceValue) : null
            this.referenceType = opObj.ReferenceType
            if (opObj.EquipmentQuantity) {
                this.equipmentQuantity = opObj.EquipmentQuantity.map((type: any) => new OpEquipmentType(type))
            }
        }
    }

    public toJSON(compressed: boolean): any {

        return {
            ReferenceValue: this.referenceValue,
            ReferenceType: this.referenceType,
            EquipmentQuantity: this.equipmentQuantity.map((equipment: OpEquipmentType) => equipment.toJSON()),
        }
    }

    // #endregion
}